export enum ShareType {
  Facebook = 'facebook',
  Twitter = 'twitter',
  LinkedIn = 'linkedin',
  Email = 'email',
  Copy = 'copy',
}
